import { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import UserNav from './UserNav';
import './profile.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function Profile() {

  return (
    <div>
      <div>
        <UserNav />
      </div>
    </div>
  )
}

export default Profile